<template>
  <l-rows>
    <a-title
      :text="$t('reporting.casinoPerformanceReport')"
    />
    <!-- Filter -->
    <l-columns>
      <integration-select
        v-model="integrationId"
      />
      <currency-select
        v-model="currency"
        fullwidth
      />
      <m-input-date
        v-model="from"
        :label="$t('common.start')"
      />
      <m-input-date
        v-model="to"
        :label="$t('common.end')"
      />
    </l-columns>
    <a-box>
      <div class="table-wrapper">
        <table class="table">
          <thead>
            <tr>
              <th
                v-for="column in columns"
                :key="column.field"
                :class="column.contentPosition"
              >
                {{ column.header }}
              </th>
            </tr>
          </thead>
          <tbody v-if="!pageMeta.loading">
            <tr
              v-for="item in page.casinoPerformanceReports"
              :key="item.id"
            >
              <td
                v-for="column in columns"
                :key="column.field"
                :class="column.contentPosition"
              >
                {{ column.filter ? column.filter(item[column.field], item) : item[column.field] }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <l-rows>
        <a-loading
          v-if="pageMeta.loading"
          loading
        />
        <l-columns
          v-else-if="noEntries"
          centered-x
        >
          <l-columns-column size="narrow">
            {{ $t('common.noResults') }}
          </l-columns-column>
        </l-columns>
      </l-rows>
      <div class="button-box">
        <a-button
          asynch
          type="button"
          variant="primary"
          :text="this.$t('reporting.downloadReport')"
          @click="downloadCasinoPerformance"
        />
      </div>
    </a-box>
  </l-rows>
</template>

<script>
  import { AButton, ABox, ALoading, ATitle, LColumns, LColumnsColumn, LRows, MInputDate } from 'codefabrik-gui-vue'
  import { IntegrationSelect, CurrencySelect } from '@/components'
  import { reportingService } from '@/services'
  import useQuery from 'codefabrik-gui-vue/src/apollo/mixins/useQuery'
  import {formatMoney, formatPercent, toast} from '@/shared'

  export default {
    name: 'CasinoPerformanceReportList',
    components: { AButton, IntegrationSelect, CurrencySelect, LRows, ATitle, MInputDate, LColumns, LColumnsColumn, ABox, ALoading },
    data () {
      return {
        integrationId: null,
        currency: null,
        from: null,
        to: null,
        limit: 0,
        offset: 0
      }
    },
    computed: {
      columns () {
        return [
          {
            header: this.$t('casinos.name'),
            field: 'casinoName',
          },
          {
            header: this.$t('casinos.id'),
            field: 'casinoId',
          },
          {
            header: this.$t('common.rtp'),
            field: 'rtp',
            contentPosition: 'right',
            filter: formatPercent
          },
          {
            header: this.$t('reporting.gamesPlayed'),
            field: 'gameCycles',
            contentPosition: 'right'
          },
          {
            header: this.$t('reporting.ggr'),
            field: 'ggr',
            contentPosition: 'right',
            filter: (value, item) => formatMoney(value, item.currency)
          },
          {
            header: this.$t('common.totalWagered'),
            field: 'wagered',
            contentPosition: 'right',
            filter: (value, item) => formatMoney(value, item.currency)
          },
          {
            header: this.$t('common.totalWon'),
            field: 'won',
            contentPosition: 'right',
            filter: (value, item) => formatMoney(value, item.currency)
          },
          {
            header: this.$t('common.currency'),
            field: 'currency',
          },
        ]
      },
      noEntries () {
        return this.page.gamePerformanceReports != null && this.page.gamePerformanceReports.length === 0
      }
    },
    methods: {
      async displayError(response) {
        toast.showErrorToast(this.$t(await response.text()))
      },
      handlePageChange (pageNumber) {
        this.offset = (pageNumber - 1) * this.limit
      },
      downloadCasinoPerformance () {
        let data = {integrationId: this.integrationId, currency: this.currency, from: this.from, to: this.to, offset: this.offset, limit: this.limit};
        reportingService
          .exportCasinoPerformanceToExcel(data)
          .catch(this.displayError)
      },
    },
    mixins: [
      useQuery({
        name: 'page',
        serviceFn: reportingService.getCasinoPerformanceRevenueReportPage,
        skipIf () {
          return this.integrationId == null
        },
        variables () {
          return {
            input: {
              integrationId: this.integrationId,
              currency: this.currency,
              from: this.from,
              to: this.to,
              limit: this.limit,
              offset: this.offset
            }
          }
        }
      })
    ]
  }
</script>

<style lang="scss" scoped>
.table-wrapper {
  overflow: scroll;

  th, td {
    white-space: nowrap;
  }

  th.right, td.right {
    text-align: right;
  }
}
.button-box{
  margin-top: 10px;
  text-align: right
}
.sum-col{
  text-align: right;
  font-weight: bold;
}
.sum-curr{
  font-weight: bold;
}
.button-box{
  margin-top: 10px;
  text-align: right
}
</style>
